import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBXYsSD4hGOt_wxSm9HKNTxkCz-AQPLyMo",
  authDomain: "ftm-app-bb018.firebaseapp.com",
  databaseURL: "https://ftm-app-bb018.firebaseio.com",
  projectId: "ftm-app-bb018",
  storageBucket: "ftm-app-bb018.appspot.com",
  messagingSenderId: "204843784760",
  appId: "1:204843784760:web:e335133ca92858a4aca4cd",
  measurementId: "G-TE95QDX1CK",
};

/* const firebaseConfig = {
  apiKey: "AIzaSyCdAuAIpN-esro_WTBcok3h63OOVXzljRY",
  authDomain: "clone-f0d2e.firebaseapp.com",
  databaseURL: "https://clone-f0d2e.firebaseio.com",
  projectId: "clone-f0d2e",
  storageBucket: "clone-f0d2e.appspot.com",
  messagingSenderId: "593948993759",
  appId: "1:593948993759:web:754a1a3ac900ade865e16a",
  measurementId: "G-TWH2DE306Q",
}; */

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
// const User = firebase.User;

export { db, auth };
